<template>
    <v-data-table
      style="width: 100%;"
      fixed-header
      :items="maps"
      :headers="headers"
      hide-default-footer
      disable-pagination
    >
        <template v-slot:item.name="{ item }">
            <div class="blue--text">{{ item.name }}</div>
        </template>

        <template v-slot:item.owner="{ item }">
            <div>{{ getUserName(item) }}</div>
        </template>

        <template v-slot:item.checksum="{ item }">
<!--            <v-card-text>{{ Math.round(item.size/1024) }}kb</v-card-text>-->
            <div>{{ item.checksum }}</div>
        </template>

        <template v-slot:item.created="{ item }">
            <div class="text-no-wrap">{{ item.created | formatDate }}</div>
        </template>

        <template v-slot:item.aud="{ item }">
            <v-btn
              :disabled="!ifCanEditAudience()"
              outlined
              color="orange"
              class="mr-1"
              @click="onPressEditAudience(item)"
            >
                {{item.aud}}
            </v-btn>
        </template>

        <template v-slot:item.version="{ item }">
            <v-btn
              :disabled="!ifCanEditVersion()"
              outlined
              color="green"
              class="mr-1"
              @click="onPressEditVersion(item)"
            >
                {{ item.minver || '-'}} - {{ item.maxver || '-'}}
            </v-btn>
        </template>

        <template v-slot:item.custom_name="{ item }">
            <v-btn
              outlined
              color="light-blue"
              class="mr-1"
              @click="onPressEditCustomName(item)"
            >
                {{ item.custom_name }}
            </v-btn>
        </template>

        <template v-slot:item.actions="{ item }">
          <div class="d-flex">
            <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      :disabled="!ifCanExport()"
                      :loading="exporting(item.id)"
                      icon
                      color="green"
                      v-bind="attrs"
                      v-on="on"
                      class="mr-1"
                      @click="onPressExport(item)"
                    >
                        <v-icon size="22">mdi-download</v-icon>
                    </v-btn>
                </template>
                <span>Export map</span>
            </v-tooltip>
            <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      :disabled="!ifCanDublicate()"
                      :loading="dublicating(item.id)"
                      icon
                      color="orange"
                      v-bind="attrs"
                      v-on="on"
                      class="mr-1"
                      @click="onPressDublicate(item)"
                    >
                        <v-icon size="19">mdi-file-multiple-outline</v-icon>
                    </v-btn>
                </template>
                <span>Dublicate map</span>
            </v-tooltip>
            <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      :disabled="!ifCanDelete()"
                      :loading="deleting(item.id)"
                      icon
                      color="red"
                      v-bind="attrs"
                      v-on="on"
                      class="mr-1"
                      @click="onPressDelete(item)"
                    >
                        <v-icon size="22">mdi-delete</v-icon>
                    </v-btn>
                </template>
                <span>Delete map</span>
            </v-tooltip>
            <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      :disabled="!ifCanAddToDeploy()"
                      icon
                      color="blue"
                      v-bind="attrs"
                      v-on="on"
                      class="mr-1"
                      @click="onPressAddToDeploy(item.name)"
                    >
                        <v-icon size="22">mdi-folder-plus</v-icon>
                    </v-btn>
                </template>
                <span>Add to deploy</span>
            </v-tooltip>
          </div>
        </template>
    </v-data-table>
</template>

<script>

import {MapBackendUtils} from "@/modules/mmaps/database/MapBackendUtils";
import {PermissionsStoreUtils} from "@/modules/mpermissions/database/PermissionsStoreUtils";
import {SlackLogManager} from "@/common/SlackLogManager";

export default {
    name: "m-maps-list",
    data: () => ({
        buttonDeleting:'',
        buttonDublicating:'',
        buttonExporting:'',
        headers: [
            {text: 'Name', sortable: true, value: 'name', class: "white blue--text", color: "red"},
            {text: 'Owner', sortable: true, value: 'owner', class: "white blue--text", color: "red"},
            {text: 'Created', sortable: true, value: 'created', class: "white blue--text", color: "red"},
            {text: 'Checksum', sortable: true, value: 'checksum', class: "white blue--text", color: "red"},
            {text: 'Custom Name', sortable: true, value: 'custom_name', class: "white blue--text", color: "red"},
            {text: 'Audiences', sortable: true, value: 'aud', class: "white blue--text", color: "red"},
            {text: 'Version', sortable: true, value: 'version', class: "white blue--text", color: "red"},
            {text: 'Actions', sortable: false, value: 'actions', class: "white blue--text", width:'15%', align:'end'}
        ],
    }),
    methods:{
        getMyUserUid(){
            return PermissionsStoreUtils.getMyUserUid();
        },
        ifCanEditVersion(){
            return PermissionsStoreUtils.getPermission(this.getMyUserUid(), PermissionsStoreUtils.MAP_TAB.subpermissions.MAP_TAB_EDIT_VER.id)
        },
        ifCanEditAudience(){
            return PermissionsStoreUtils.getPermission(this.getMyUserUid(), PermissionsStoreUtils.MAP_TAB.subpermissions.MAP_TAB_EDIT_AUD.id)
        },
        ifCanAddToDeploy(){
            return PermissionsStoreUtils.getPermission(this.getMyUserUid(), PermissionsStoreUtils.DEPLOY_TAB.subpermissions.DEPLOY_TAB_ADD_MAP_TO_DEPLOY.id)
        },
        ifCanDelete(){
            return PermissionsStoreUtils.getPermission(this.getMyUserUid(), PermissionsStoreUtils.MAP_TAB.subpermissions.MAP_TAB_DELETE.id)
        },
        ifCanDublicate(){
            return PermissionsStoreUtils.getPermission(this.getMyUserUid(), PermissionsStoreUtils.MAP_TAB.subpermissions.MAP_TAB_DUBLICATE.id)
        },
        ifCanExport(){
            return PermissionsStoreUtils.getPermission(this.getMyUserUid(), PermissionsStoreUtils.MAP_TAB.subpermissions.MAP_TAB_EXPORT.id)
        },
        getUserName(user){
            return PermissionsStoreUtils.getUserName(user.owner)
        },
        // isProduction(){
        //     return process.env.VUE_APP_FB_PROJECTID == 'mira-merge---production'
        // },
        onPressAddToDeploy(name){
            this.$store.commit('deploy-store/addPendingForDeploy', name)
            this.$notify({title: 'Added: ' + name, text: "", type: "succes"});
        },
        onPressEditAudience(map){
            this.$emit('show-m-maps-set-audience-popup', map)
        },
        onPressEditVersion(map){
            this.$emit('show-popup-edit-version', map)
        },
        onPressEditCustomName(map){
            this.$emit('show-popup-edit-custom-name', map)
        },
        onPressExport(map){
            this.buttonExporting = map.id
            MapBackendUtils.getMap(map.name)
            .then((mapXml) => {
                this.buttonExporting = ''
                let FileSaver = require('file-saver');
                let blob = new Blob([mapXml[0]], {type: "text/plain;charset=utf-8"});
                FileSaver.saveAs(blob, "m_" + map.version + ".tmx" );
                this.$notify({title: 'Map successfully exported!', text: "", type: "succes"});
            })
            .catch((error) => {
                this.buttonExporting = ''
                this.$notify({title: 'Map export failed!', text: error, type: "error"});
            })
        },
        onPressDublicate(map){
            this.buttonDublicating = map.id
            MapBackendUtils.duplicateMap(map.name)
            .then(() => {
                this.buttonDublicating = ''
                this.$notify({title: 'Map successfully dublicated!', text: "", type: "succes"});
            })
            .catch((error) => {
                this.buttonDublicating = ''
                this.$notify({title: 'Map dublicate failed!', text: error, type: "error"});
            })
        },
        onPressDelete(map){
            this.$confirm("Are you sure?")
            .then(() => {
                this.buttonDeleting = map.id
                MapBackendUtils.removeMap(map.name)
                .then(() => {
                    this.buttonDeleting = ''
                    this.$notify({title: 'Map successfully deleted!', text: "", type: "succes"});

                    let deployData = {
                        'icon_emoji': ':hammer:',
                        'text': "<@"+PermissionsStoreUtils.getMyName()+"> delete MAP",
                        'attachments': [{
                            'color': '#ff004c',
                            'fields': [
                                {"title": "Environment", 'value': SlackLogManager.getEnv(), 'short': true},
                                {"title": "Name", 'value': map.name, 'short': true},
                            ]
                        }]
                    }
                    SlackLogManager.log(deployData)

                })
                .catch((error) => {
                    this.buttonDeleting = ''
                    this.$notify({title: 'Map delete failed!', text: error, type: "error"});                                                                             
                })
            });
        },
        dublicating(id){
            return this.buttonDublicating == id
        },
        deleting(id){
            return this.buttonDeleting == id
        },
        exporting(id){
            return this.buttonExporting == id
        },
    },
    computed:{
        maps(){
            return MapBackendUtils.getMaps()
        }
    }
}
</script>

<style scoped>
</style>